<button
	[matTooltip]="'feedback-session-header_presenter-attachment-tooltip' | translate"
	app-session-attachments-button
	[attachmentsCount]="attachmentsCount"
	[goCdkPopover]="attachmentsTemplate"
	goCdkPopoverTrigger="click"
	goCdkPopoverPosition="below"
	goCdkPopoverBgColor="var(--color-off-white)"
	goCdkPopoverShowArrow="true"
	aria-label="{{
		(attachmentsCount > 1 ?
			'feedback-session-header_presenter-attachment-aria-label-plural' :
			'feedback-session-header_presenter-attachment-aria-label-singular') | translate:{count: attachmentsCount}
	}}">
</button>

<ng-template #attachmentsTemplate>
	<div>
		<span translate="feedback-session-header_presenter-attachments"></span>
		<session-attachments
			[session]="session"
			[group]="group"
			[user]="user"
			[readonlyMode]="readonlyMode"
			[activityName]="activityName">
		</session-attachments>
		@if (!readonlyMode && attachmentsCount === 0) {
			<h5
				translate="feedback-session-header_add-attachments">
			</h5>
		}
	</div>
</ng-template>
